import { StateLabel } from "@delibrandev/utils";
import { useEffect } from "react";
import { formatMoney, priceWithTax } from "../../../utils/pricing";

export const Attributes = ({ group, index, handleOption, itemIds, updateRequirements, taxSource }) => {
  const isMandatory = group.mandatory;
  const maxItems = group.maxItems;
  const groupItemsAdded = group.items.filter((item) => itemIds.includes(item.itemId)).length;

  const handleAlerts = () => {
    let mandatory = false;
    let maxItemsReached = false;

    if (isMandatory && groupItemsAdded === 0) mandatory = true;

    if (isMandatory && group.maxItems > 0 && (groupItemsAdded > group.maxItems || groupItemsAdded === 0)) {
      maxItemsReached = true;
    }

    return { maxItems: maxItemsReached, mandatory };
  };

  const handleAttribute = (item) => {
    handleOption(item);
    const isAdd = !itemIds.includes(item.itemId);
    let cartError = "";

    if (isAdd) {
      if (groupItemsAdded + 1 > maxItems) cartError = "Límite de complementos superado";
    } else {
      if (groupItemsAdded - 1 > maxItems) cartError = "Falta agregar complementos";
      if (groupItemsAdded === maxItems && isMandatory) {
        cartError = "Falta seleccionar un complemento obligatorio";
      }
    }

    updateRequirements({ id: group.itemGroupId, error: cartError });
  };

  const handleKeyDown = (event, item) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleAttribute(item);
    }
  };

  useEffect(() => {
    if (isMandatory) {
      updateRequirements({
        id: group.itemGroupId,
        error: "Falta seleccionar un complemento obligatorio",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="flex-start" style={{ alignItems: "center", gap: "10px" }}>
        <h5>
          <b>{group.name || "Completa tu pedido"}</b>
        </h5>
        <div style={{ marginBottom: "5px" }}>
          {handleAlerts().maxItems && <StateLabel text={`${group.maxItems} máximo`} state="pending" />}
        </div>
        <div style={{ marginBottom: "5px" }}>
          {handleAlerts().mandatory && <StateLabel text="Obligatorio" state="pending" />}
        </div>
      </div>

      <div
        className="attribute-options-list"
        role="group"
        aria-label={group.name || "Complementos"}
        data-group-index={index}
      >
        {group.items?.map((item) => {
          if (!item.name) return null;
          const isSelected = itemIds.includes(item.itemId);

          return (
            <div
              className={`attribute-option ${isSelected ? "is-selected" : ""}`}
              key={item.itemId}
              role="checkbox"
              aria-checked={isSelected}
              tabIndex={0}
              onClick={() => handleAttribute(item)}
              onKeyDown={(event) => handleKeyDown(event, item)}
            >
              <span>{item.name.charAt(0).toUpperCase() + item.name.slice(1)}</span>
              <small>+{formatMoney(priceWithTax(Number(item.price) || 0, taxSource))}</small>
            </div>
          );
        })}
      </div>
    </>
  );
};
